// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable prefer-named-capture-group, react/no-array-index-key */
import React from "react"
import * as R from "ramda"
import Button from "@kiwicom/frontend-common/components/Button/Button"

function getBundleAndVendorScripts() {
  return [].slice // Convert HTMLCollection to array
    .call(document.getElementsByTagName("script")) // Get all script tags
    .map((x) => x.src) // Get just src attributes
    .filter((x) => /\/scripts\/(bundle|vendor)\./.test(x)) // Filter just vendor and bundle
    .map((x) => x.split("/")[4]) // get just name "https://en.skypicker.com/scripts/vendor.XYZ.js" => "vendor.XYZ.js"
}

function getVisitorInfo() {
  return R.values(
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line react/jsx-filename-extension
    R.mapObjIndexed((v, k) => <li>{`${k}: ${v}`}</li>, window.SP_GLOBALS.RELEASE_INFO),
  )
}

const OtherDebugInfo = () => (
  <div>
    <h4>Visitor info</h4>
    <ul>{getVisitorInfo()}</ul>

    <h4>Scripts</h4>
    <ul>
      {getBundleAndVendorScripts().map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
    <hr />
    <Button
      onClick={() => {
        throw new Error("Testing error")
      }}
    >
      Throw testing error
    </Button>
    <Button
      onClick={() => {
        setTimeout(() => {
          throw new Error("Testing error, in setTimeout")
        }, 500)
      }}
    >
      Throw testing error, in setTimeout 500ms
    </Button>
  </div>
)

export default OtherDebugInfo
